import script from "./adpopup.vue?vue&type=script&setup=true&lang=js"
export * from "./adpopup.vue?vue&type=script&setup=true&lang=js"

import "./adpopup.vue?vue&type=style&index=0&id=32402828&lang=less&scoped=true"
import "./adpopup.vue?vue&type=style&index=1&id=32402828&lang=css"

import exportComponent from "/data/jenkins/workspace/pay.7pa.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32402828"]])

export default __exports__